import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-big-bang-progress-ticket',
  templateUrl: './big-bang-progress-ticket.component.html',
  styleUrls: ['./big-bang-progress-ticket.component.scss'],
})
export class BigBangProgressTicketComponent implements OnInit {
  @Input() ticketNumber: number;
  @Input() percentageCompleted: number;

  formatedTicketNumber: string;

  ngOnInit(): void {
    this.formatedTicketNumber = this.ticketNumber < 10 ? `0${this.ticketNumber}` : this.ticketNumber.toString();
  }
}
